/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { DialogRef } from '@ngneat/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Vehicle } from 'rest-client';

import { VehicleService } from '@app/modules/core/services/vehicle/vehicle.service';
import {
  RequestedVehicleDataResponse,
  RequestedVehicleDataPayload,
} from '@app/modules/shared/models';

/**
 * > Shows custom selectors when Car Service Family requires more data.
 */
@UntilDestroy()
@Component({
  selector: 'bkg-vehicle-dialog-modify-km',
  templateUrl: './vehicle-dialog-modify-km.component.html',
})
export class VehicleDialogModifyKmComponent implements OnInit {
  requestedDataForm: FormGroup;

  vehicleData: Vehicle;
  isLogged: boolean;

  constructor(private vehicleService: VehicleService, public ref: DialogRef) {}

  ngOnInit(): void {
    this.vehicleData = this.ref.data?.vehicleData as Vehicle;
    this.isLogged = this.ref.data?.isLogged as boolean;
    this.initDataFlow();
  }

  get checkDisabled(): boolean {
    let kmParsed = this.getControlValue('km')?.toString() || null;
    if (kmParsed) kmParsed = kmParsed.replace(/\./g, '');

    return (
      this.requestedDataForm.invalid ||
      (this.vehicleData.km?.toString() || null) === kmParsed
    );
  }

  private initDataFlow(): void {
    this.buildRequestedDataForm();
  }

  private buildRequestedDataForm = (): void => {
    const group = {} as Record<string, FormControl>;

    group['km'] = new FormControl('', [Validators.required]);
    if (this.vehicleData.km) {
      group['km'].setValue(this.vehicleData.km);
    }

    this.requestedDataForm = new FormGroup(group);
  };

  private getControl(controlName: string): AbstractControl {
    return this.requestedDataForm.get(controlName);
  }

  onClickClose(): void {
    this.ref.close(false);
  }

  submitData = (): void => {
    const id = Number(this.vehicleData.id);
    const requestedDataPayload = this.createPayload();
    if (this.isLogged) {
      this.sendRequestData(id, requestedDataPayload);
    } else {
      this.sendRequestDataGuest(id, requestedDataPayload);
    }
  };

  private createPayload = (): RequestedVehicleDataPayload => {
    const payload: RequestedVehicleDataPayload = {};

    let kmParsed = this.getControlValue('km').toString();
    kmParsed = kmParsed.replace(/\./g, '');
    payload.km = Number(kmParsed);

    return payload;
  };

  private getControlValue(controlName: string): string | number {
    return this.getControl(controlName).value as string | number;
  }

  private sendRequestData = (
    id: number,
    payload: RequestedVehicleDataPayload
  ): void => {
    this.vehicleService
      .setRequestedVehicleData(id, payload)
      .pipe(untilDestroyed(this))
      .subscribe(
        (response: unknown) => {
          const { vehicle } = response as RequestedVehicleDataResponse;
          this.ref.close(vehicle);
        },
        (error: HttpErrorResponse) => console.log(error)
      );
  };

  private sendRequestDataGuest = (
    id: number,
    payload: RequestedVehicleDataPayload
  ): void => {
    this.vehicleService
      .setRequestedVehicleDataGuest(id, payload)
      .pipe(untilDestroyed(this))
      .subscribe(
        (response: unknown) => {
          const { vehicle } = response as RequestedVehicleDataResponse;
          this.ref.close(vehicle);
        },
        (error: HttpErrorResponse) => console.log(error)
      );
  };
}
